import React from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const SectionActionButton = ({
  id,
  setEdit,
  setSectionId,
  toggleShowAddEditSection,
  toggleShowDelete,
  is_used,
}) => {
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditSection();
                setSectionId(id);
              }}
            />
          </span>
        </CustomTooltip>
        {!is_used && (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setSectionId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>
    </>
  );
};

export default SectionActionButton;
